exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sdk-advert .btn-box[data-v-1bbcd438]{padding-top:100px;text-align:center}.screen-box[data-v-1bbcd438],.sdk-advert .title[data-v-1bbcd438],.time-box[data-v-1bbcd438]{margin-bottom:20px}.my-time[data-v-1bbcd438]{display:inline-block;width:120px}.btn-edit[data-v-1bbcd438]{color:#01a6ef;cursor:pointer;margin-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1bbcd438&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/sdkAdvert/sdkAdvert.vue
// module id = 462
// module chunks = 0